import { useUserContext } from "../user_context/UserContext";
import { useOrganizationContext } from "../organization_context/OrganizationContext";
import { useEmployee } from "../employee_context/EmployeeContext";
import { useGeneralDocumentContext } from "../general_document_context/GeneralDocumentContext";
import { useInventoryContext } from "../inventory_context/InventoryContext";
import { useSubscriptionContext } from "../subscription_context/SubscriptionContext";
import { createContext, useContext } from "react";
import { useAuthContext } from "../auth/AuthContext";
  
const SignOutContext = createContext(null);
  
export const SignOutProvider = ({ children }) => {
  const { resetUserContext } = useUserContext();
  const { resetOrganizationContext } = useOrganizationContext();
  const { resetEmployeeContext } = useEmployee();
  const { resetGeneralDocumentContext } = useGeneralDocumentContext();
  const { resetInventoryContext } = useInventoryContext();
  const { resetSubscriptionContext } = useSubscriptionContext();
  const { logOut } = useAuthContext();
  
  const clearAndSignOut = async (navigate = null) => {
    try {
      await logOut();
      resetUserContext();
      resetOrganizationContext();
      resetEmployeeContext();
      resetGeneralDocumentContext();
      resetInventoryContext();
      resetSubscriptionContext();
      
      if (navigate) {
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 100);
      }
    } catch (error) {
      // Handle error silently
    }
  };
  
  return (
    <SignOutContext.Provider value={{ clearAndSignOut }}>
      {children}
    </SignOutContext.Provider>
  );
};

export const useSignOutContext = () => {
  return useContext(SignOutContext);
};
